<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="sa-flexbox-body-content">
                    <div class="sa-flexbox" style="padding-bottom: 20px">
                        <div class="sa-flexbox-header">
                            <div class="sa-toolbar">
                                <div class="sa-toolbar-title">
                                    <span class="sa-flexbox-body-title">Sospensioni percorso ADI</span>
                                </div>
                                <div class="sa-toolbar-separator"></div>
                                <div class="sa-toolbar-button">
                                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" class="mb-2" :disabled="!canCreate" @click="onClickNuovaSospensione">
                                        <font-awesome-icon icon="plus" />
                                        Sospendi percorso
                                    </b-button>
                                </div>
                            </div>
                        </div>

                        <b-alert :show="!!loadError" variant="danger" class="mx-2 mt-2" role="alert">
                            {{ loadError }}
                            <b-button size="sm" variant="outline-danger" :disabled="isBusy" @click="loadData">Riprova</b-button>
                        </b-alert>

                        <div v-if="sospensioneAperta" class="alert alert-warning mx-2 mt-2 mb-2">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>Percorso ADI sospeso</strong>
                                    <div>
                                        Dal:
                                        <strong>{{ formatDateTime(sospensioneAperta.dataOraUscita) }}</strong>
                                    </div>
                                    <div v-if="sospensioneAperta.motivo">
                                        Motivo:
                                        <strong>{{ sospensioneAperta.motivo }}</strong>
                                    </div>
                                </div>

                                <b-button size="sm" variant="outline-success" :disabled="isBusy" @click="onClickRiprendiPercorso(sospensioneAperta)">
                                    <font-awesome-icon icon="play" />
                                    Riprendi percorso
                                </b-button>
                            </div>
                        </div>

                        <div class="sa-flexbox-body">
                            <div style="width: 100%" class="b-table-sticky-header">
                                <b-table ref="table" sticky-header stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :busy="checkingSospensioneAperta" sort-icon-left head-variant="light" table-class="sa-b-table" show-empty empty-text="Nessuna sospensione registrata">
                                    <template #table-busy>
                                        <div class="text-center py-4" role="status">
                                            <b-spinner small class="mr-2" />
                                            Caricamento sospensioni...
                                        </div>
                                    </template>

                                    <template #cell(index)="row">
                                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                                    </template>

                                    <template #cell(dataOraUscita)="{ item }">
                                        <span v-if="item.dataOraUscita">{{ formatDateTime(item.dataOraUscita) }}</span>
                                        <span v-else>---</span>
                                    </template>

                                    <template #cell(dataOraEntrata)="{ item }">
                                        <span v-if="item.dataOraEntrata">{{ formatDateTime(item.dataOraEntrata) }}</span>
                                        <b-badge v-else-if="isSospensioneAperta(item)" variant="warning">In corso</b-badge>
                                        <span v-else>---</span>
                                    </template>

                                    <template #cell(stato)="{ item }">
                                        <b-badge v-if="isSospensioneAperta(item)" variant="warning">SOSPESO</b-badge>
                                        <b-badge v-else-if="isPercorsoRipreso(item)" variant="success">RIPRESO</b-badge>
                                        <span v-else>---</span>
                                    </template>

                                    <template #cell(motivo)="{ item }">
                                        {{ item.motivo || "---" }}
                                    </template>

                                    <template #cell(note)="{ item }">
                                        <div v-if="item.noteUscita || item.noteEntrata">
                                            <div v-if="item.noteUscita" class="note-item">
                                                <strong>Sospensione:</strong>
                                                {{ item.noteUscita }}
                                            </div>
                                            <div v-if="item.noteEntrata" class="note-item">
                                                <strong>Ripresa:</strong>
                                                {{ item.noteEntrata }}
                                            </div>
                                        </div>
                                        <span v-else>---</span>
                                    </template>

                                    <template #cell(actions)="{ item }">
                                        <b-container class="bv-example-row">
                                            <b-button-group>
                                                <b-button v-if="isSospensioneAperta(item)" size="sm" variant="outline-success" v-b-tooltip.hover title="Riprendi percorso ADI" aria-label="Riprendi percorso ADI" :disabled="isBusy" @click="onClickRiprendiPercorso(item)">
                                                    <font-awesome-icon icon="play" />
                                                </b-button>

                                                <b-button size="sm" variant="outline-secondary" v-b-tooltip.hover title="Visualizza sospensione" aria-label="Visualizza sospensione" :disabled="isBusy" @click="onClickVisualizza(item)">
                                                    <font-awesome-icon icon="eye" />
                                                </b-button>

                                                <b-button size="sm" variant="outline-danger" v-b-tooltip.hover title="Elimina sospensione" aria-label="Elimina sospensione" :disabled="isBusy" @click="onClickDelete(item)">
                                                    <font-awesome-icon icon="trash" />
                                                </b-button>
                                            </b-button-group>
                                        </b-container>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div class="sa-flexbox-footer">
                            <div class="sa-list-component-footer" style="padding-bottom: 10px">
                                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                                    <b-col lg="3">
                                        <p>Record Totali: {{ rows }}</p>
                                    </b-col>
                                    <b-col lg="9">
                                        <b-pagination v-model="currentPage" :disabled="isBusy" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sa-flexbox-body-right"></div>
            </div>
        </div>

        <!-- MODALE -->
        <b-modal ref="mdlSospensioneAdi" :title="modalTitle" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
            <!-- NUOVA SOSPENSIONE -->
            <template v-if="modalMode === 'NUOVA'">
                <div class="alert alert-warning">
                    <strong>Sospensione percorso assistenziale ADI</strong>

                    <p class="mb-0 mt-1">Durante il periodo indicato il percorso di cura ADI risulterà sospeso.</p>
                </div>

                <b-row>
                    <b-col cols="12" md="6">
                        <label class="sa-label-data"> Data/Ora sospensione * </label>

                        <date-picker v-model="jsonDataSospensione.dataOraUscita" format="DD/MM/YYYY HH:mm" value-type="timestamp" type="datetime" placeholder="Seleziona data e ora" />
                    </b-col>

                    <b-col cols="12" md="6">
                        <label class="sa-label-data"> Motivo sospensione * </label>

                        <b-form-select v-model="jsonDataSospensione.motivo" :options="motivoOptions" value-field="voce" text-field="voce">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona motivo - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col cols="12">
                        <label class="sa-label-data">Note sospensione</label>

                        <b-form-textarea v-model="jsonDataSospensione.noteUscita" rows="5" max-rows="8" placeholder="Inserisci eventuali note relative alla sospensione..." />
                    </b-col>
                </b-row>
            </template>

            <!-- RIPRESA -->
            <template v-else-if="modalMode === 'RIPRESA'">
                <div class="alert alert-info">
                    <strong>Ripresa percorso assistenziale ADI</strong>

                    <hr />

                    <div>
                        <strong>Inizio sospensione:</strong>
                        {{ formatDateTime(jsonDataSospensione.dataOraUscita) }}
                    </div>

                    <div v-if="jsonDataSospensione.motivo">
                        <strong>Motivo:</strong>
                        {{ jsonDataSospensione.motivo }}
                    </div>

                    <div v-if="jsonDataSospensione.noteUscita">
                        <strong>Note sospensione:</strong>
                        {{ jsonDataSospensione.noteUscita }}
                    </div>
                </div>

                <b-row>
                    <b-col cols="12">
                        <label class="sa-label-data"> Data/Ora ripresa percorso * </label>

                        <date-picker v-model="jsonDataSospensione.dataOraEntrata" format="DD/MM/YYYY HH:mm" value-type="timestamp" type="datetime" placeholder="Seleziona data e ora" />
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col cols="12">
                        <label class="sa-label-data">Note ripresa</label>

                        <b-form-textarea v-model="jsonDataSospensione.noteEntrata" rows="5" max-rows="8" placeholder="Inserisci eventuali note relative alla ripresa del percorso..." />
                    </b-col>
                </b-row>
            </template>

            <!-- VISUALIZZAZIONE -->
            <template v-else-if="modalMode === 'VIEW'">
                <b-row>
                    <b-col cols="12" sm="6">
                        <label class="sa-label-data">Inizio sospensione</label>
                        <div>
                            {{ formatDateTime(jsonDataSospensione.dataOraUscita) }}
                        </div>
                    </b-col>

                    <b-col cols="12" sm="6">
                        <label class="sa-label-data">Fine sospensione</label>

                        <div v-if="jsonDataSospensione.dataOraEntrata">
                            {{ formatDateTime(jsonDataSospensione.dataOraEntrata) }}
                        </div>

                        <b-badge v-else-if="isSospensioneAperta(jsonDataSospensione)" variant="warning"> Sospensione in corso </b-badge>

                        <span v-else>---</span>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col cols="12">
                        <label class="sa-label-data">Motivo</label>
                        <div>{{ jsonDataSospensione.motivo || "---" }}</div>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col cols="12">
                        <label class="sa-label-data">Note sospensione</label>
                        <div class="note-item">
                            {{ jsonDataSospensione.noteUscita || "---" }}
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col cols="12">
                        <label class="sa-label-data">Note ripresa</label>
                        <div class="note-item">
                            {{ jsonDataSospensione.noteEntrata || "---" }}
                        </div>
                    </b-col>
                </b-row>
            </template>

            <template #modal-footer>
                <b-button size="md" variant="outline-secondary" :disabled="isSaving" @click="onCloseModal">
                    {{ modalMode === "VIEW" ? "Chiudi" : "Annulla" }}
                </b-button>

                <b-button v-if="modalMode !== 'VIEW'" size="md" variant="outline-success" :disabled="!canSave" @click="onClickSalva">
                    <b-spinner v-if="isSaving" small class="mr-2" />

                    <template v-if="modalMode === 'NUOVA'"> Sospendi percorso </template>

                    <template v-else-if="modalMode === 'RIPRESA'"> Riprendi percorso </template>
                </b-button>
            </template>

            <modal-error ref="cmpModalError" />
        </b-modal>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

const TIPO_SOSPENSIONE_ADI = "SOSPENSIONE_ADI";
const TIPO_RIPRESA_ADI = "RIPRESA_ADI";

function createEmptySospensione() {
    return {
        id: null,
        idAccettazione: null,

        dataOraUscitaProgrammata: null,
        dataOraUscita: null,

        dataOraEntrataProgrammata: null,
        dataOraEntrata: null,

        tipo: null,
        motivo: null,
        assenteNellaData: true,

        noteUscitaProgrammata: null,
        noteUscita: null,
        noteEntrata: null,
    };
}

export default {
    name: "RsaPazienteSospensioneAdiComponent",

    mixins: [UtilityMixin],

    components: {
        DatePicker,
        ModalError,
    },

    props: {
        idAccettazione: {
            type: [String, Number],
            default: null,
        },

        jsonDataAccettazione: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },

    data() {
        return {
            pathResource: "/rsapazientepresenze",
            pathResourceDizionario: "/rsadizionario",

            perPage: 50,
            currentPage: 1,

            loadRequestId: 0,
            contextVersion: 0,

            loadError: null,
            isSaving: false,
            isDeleting: false,

            // Contiene esclusivamente record ADI.
            items: [],

            filtro: {
                idAccettazione: null,
            },

            checkingSospensioneAperta: false,

            modalMode: null,
            jsonDataSospensione: createEmptySospensione(),

            motivoOptions: [],

            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Inizio sospensione",
                    key: "dataOraUscita",
                    sortable: true,
                },
                {
                    label: "Fine sospensione",
                    key: "dataOraEntrata",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: false,
                },
                {
                    label: "Motivo",
                    key: "motivo",
                    sortable: true,
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: false,
                },
                {
                    label: "",
                    key: "actions",
                    sortable: false,
                    class: "sa-table-column-action-double",
                    thStyle: "width: 10rem",
                },
            ],
        };
    },

    computed: {
        rows() {
            return this.items.length;
        },

        sospensioneAperta() {
            return this.items.find((item) => this.isSospensioneAperta(item)) || null;
        },

        hasSospensioneAperta() {
            return !!this.sospensioneAperta;
        },

        isBusy() {
            return this.checkingSospensioneAperta || this.isSaving || this.isDeleting;
        },

        canCreate() {
            return !!this.idAccettazione && !this.isBusy && !this.loadError && !this.hasSospensioneAperta && !this.isAccettazioneChiusa();
        },

        modalTitle() {
            switch (this.modalMode) {
                case "NUOVA":
                    return "Sospendi percorso ADI";
                case "RIPRESA":
                    return "Riprendi percorso ADI";
                case "VIEW":
                    return "Dettaglio sospensione ADI";
                default:
                    return "Sospensione ADI";
            }
        },

        canSave() {
            if (this.isBusy || !this.idAccettazione || this.jsonDataSospensione.idAccettazione != this.idAccettazione) {
                return false;
            }

            const inizio = this.toTimestamp(this.jsonDataSospensione.dataOraUscita);

            if (this.modalMode === "NUOVA") {
                return this.canCreate && inizio !== null && !!this.jsonDataSospensione.motivo;
            }

            if (this.modalMode === "RIPRESA") {
                const fine = this.toTimestamp(this.jsonDataSospensione.dataOraEntrata);

                return !!this.jsonDataSospensione.id && inizio !== null && fine !== null && fine >= inizio;
            }

            return false;
        },
    },

    mounted() {
        this.loadDizionarioData();
        this.loadData();
    },

    beforeDestroy() {
        this.loadRequestId++;
        this.contextVersion++;
    },

    watch: {
        idAccettazione(newValue, oldValue) {
            if (newValue === oldValue) return;

            this.contextVersion++;

            if (this.$refs.mdlSospensioneAdi) {
                this.$refs.mdlSospensioneAdi.hide();
            }

            this.resetModal();
            this.items = [];
            this.currentPage = 1;

            this.loadData();
        },

        // La paginazione della tabella è locale:
        // cambiare pagina non richiede altre chiamate al backend.
    },

    methods: {
        init() {
            this.currentPage = 1;
            this.loadDizionarioData();
            this.loadData();
        },

        // =========================================================
        // CARICAMENTO
        // =========================================================

        loadData() {
            const requestId = ++this.loadRequestId;

            this.loadError = null;
            this.items = [];

            if (!this.idAccettazione) {
                this.checkingSospensioneAperta = false;
                this.$emit("afterLoadData");
                return;
            }

            this.filtro = {
                idAccettazione: this.idAccettazione,
            };

            this.checkingSospensioneAperta = true;
            this.$emit("beforeLoadData");

            /*
             * Recupero tutte le pagine dell'accettazione.
             * Applico il filtro ADI prima della paginazione visiva,
             * così conteggio e pagine non includono presenze ordinarie.
             */
            this.loadPresenzePage(requestId, 1, 0, []);
        },

        loadPresenzePage(requestId, page, scanned, adiItems) {
            const filtro = {
                ...this.filtro,
                page,
                forPage: this.perPage,
            };

            UtilityMixin.methods.loadDataResources(
                this.pathResource,
                filtro,
                (response) => {
                    if (requestId !== this.loadRequestId) return;

                    const data = response.data && response.data.data;

                    if (!data || !Array.isArray(data.list)) {
                        this.loadDataError(new Error("Risposta elenco presenze non valida"));
                        return;
                    }

                    const lista = data.list;
                    const total = Number(data.recordsNumber);

                    if (data.recordsNumber == null || !Number.isInteger(total) || total < 0) {
                        this.loadDataError(new Error("Conteggio presenze non valido"));
                        return;
                    }

                    lista.forEach((item) => {
                        if (this.isRecordAdi(item)) {
                            adiItems.push(item);
                        }
                    });

                    const count = scanned + lista.length;

                    if (count >= total) {
                        this.items = adiItems;

                        const lastPage = Math.max(1, Math.ceil(this.rows / this.perPage));

                        this.currentPage = Math.min(this.currentPage, lastPage);

                        this.finishLoading();
                        return;
                    }

                    if (!lista.length) {
                        this.loadDataError(new Error("Caricamento presenze incompleto"));
                        return;
                    }

                    this.loadPresenzePage(requestId, page + 1, count, adiItems);
                },
                (error) => {
                    if (requestId !== this.loadRequestId) return;
                    this.loadDataError(error);
                },
            );
        },

        loadDataError(error) {
            this.items = [];
            this.loadError = "Impossibile caricare tutte le sospensioni ADI. Riprova prima di inserire una nuova sospensione.";

            this.finishLoading(error);
        },

        finishLoading(error) {
            this.checkingSospensioneAperta = false;
            this.$emit("afterLoadData", error);
        },

        // =========================================================
        // DIZIONARIO
        // =========================================================

        loadDizionarioData() {
            UtilityMixin.methods.loadDataResources(this.pathResourceDizionario, null, this.loadDizionarioDataSuccess, null);
        },

        loadDizionarioDataSuccess(response) {
            const data = response.data && response.data.data;
            const lista = data && Array.isArray(data.list) ? data.list : [];

            const motivazioniAdi = lista.filter((item) => item.tipo === "MOTIVAZIONE_SOSPENSIONE_ADI");

            this.motivoOptions = motivazioniAdi.length ? motivazioniAdi : lista.filter((item) => item.tipo === "MOTIVAZIONE_PRESENZE_USCITE");
        },

        // loadDizionarioDataError(error) {
        //     console.error("Errore durante il caricamento delle motivazioni", error);
        // },

        // =========================================================
        // NUOVA SOSPENSIONE
        // =========================================================

        onClickNuovaSospensione() {
            if (!this.idAccettazione || this.isBusy || this.loadError) {
                return;
            }

            if (this.hasSospensioneAperta) {
                this.$bvModal.msgBoxOk("Il percorso ADI risulta già sospeso. È necessario registrare prima la ripresa del percorso.", {
                    title: "Percorso ADI già sospeso",
                    size: "md",
                    okVariant: "outline-warning",
                    centered: true,
                });
                return;
            }

            if (this.isAccettazioneChiusa()) {
                this.$bvModal.msgBoxOk("Non è possibile sospendere il percorso di un paziente dimesso o trasferito.", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            }

            this.modalMode = "NUOVA";
            this.jsonDataSospensione = this.getEmptySospensione();

            this.jsonDataSospensione.idAccettazione = this.idAccettazione;
            this.jsonDataSospensione.dataOraUscita = Date.now();
            this.jsonDataSospensione.tipo = TIPO_SOSPENSIONE_ADI;
            this.jsonDataSospensione.assenteNellaData = true;

            this.$refs.mdlSospensioneAdi.show();
        },

        // =========================================================
        // RIPRESA
        // =========================================================

        onClickRiprendiPercorso(item) {
            if (this.isBusy || !item || !item.id || !this.isSospensioneAperta(item)) {
                return;
            }

            this.modalMode = "RIPRESA";

            // Mantengo ID e dati della sospensione già registrata.
            this.jsonDataSospensione = this.clonePresenza(item);

            this.jsonDataSospensione.dataOraEntrata = Date.now();
            this.jsonDataSospensione.tipo = TIPO_RIPRESA_ADI;

            this.$refs.mdlSospensioneAdi.show();
        },

        // =========================================================
        // VISUALIZZAZIONE
        // =========================================================

        onClickVisualizza(item) {
            if (this.isBusy || !this.isRecordAdi(item)) return;

            this.modalMode = "VIEW";
            this.jsonDataSospensione = this.clonePresenza(item);

            this.$refs.mdlSospensioneAdi.show();
        },

        // =========================================================
        // SALVATAGGIO
        // =========================================================

        onClickSalva() {
            if (!this.canSave) return;

            const payload = this.clonePresenza(this.jsonDataSospensione);

            payload.dataOraUscita = this.toTimestamp(payload.dataOraUscita);

            if (this.modalMode === "NUOVA") {
                if (this.hasSospensioneAperta) return;

                payload.tipo = TIPO_SOSPENSIONE_ADI;
                payload.dataOraEntrata = null;

                payload.dataOraUscitaProgrammata = null;
                payload.dataOraEntrataProgrammata = null;

                payload.noteUscitaProgrammata = null;
                payload.noteEntrata = null;

                payload.assenteNellaData = true;
            } else if (this.modalMode === "RIPRESA") {
                payload.tipo = TIPO_RIPRESA_ADI;
                payload.dataOraEntrata = this.toTimestamp(payload.dataOraEntrata);

                if (payload.dataOraEntrata === null || payload.dataOraUscita === null || payload.dataOraEntrata < payload.dataOraUscita) {
                    return;
                }
            } else {
                return;
            }

            this.jsonDataSospensione = payload;

            const version = this.contextVersion;
            this.isSaving = true;
            this.$emit("beforeLoadData");
            UtilityMixin.methods.saveResource(
                this.pathResource,
                payload,
                (response) => {
                    this.finishMutation("isSaving", version, this.saveSuccessResponse, response);
                },
                (error) => {
                    this.finishMutation("isSaving", version, this.saveErrorResponse, error);
                },
            );
        },

        saveSuccessResponse(response) {
            const mode = this.modalMode;

            this.$refs.mdlSospensioneAdi.hide();

            this.$bvToast.toast(mode === "NUOVA" ? "Percorso ADI sospeso con successo" : "Percorso ADI ripreso con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });

            this.$emit("onSave", response, mode);
            this.resetModal();
            this.loadData();
        },

        saveErrorResponse(error) {
            this.$emit("afterLoadData", error);

            const messaggio = error && error.response && error.response.data && error.response.data.messaggio;

            this.$refs.cmpModalError.show(messaggio || "Errore durante il salvataggio della sospensione ADI");
        },

        // =========================================================
        // ELIMINAZIONE
        // =========================================================

        onClickDelete(item) {
            if (this.isBusy || !item || !item.id || !this.isRecordAdi(item)) {
                return;
            }

            const version = this.contextVersion;

            this.$bvModal
                .msgBoxConfirm("Sicuro di voler eliminare questa sospensione del percorso ADI?", {
                    title: "Elimina sospensione",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (!value || this.isBusy || version !== this.contextVersion) {
                        return;
                    }

                    const link = process.env.VUE_APP_PATH_API + this.pathResource + "/" + item.id;

                    this.isDeleting = true;
                    this.$emit("beforeLoadData");

                    UtilityMixin.methods.restCallDelete(
                        link,
                        (response) => {
                            this.finishMutation("isDeleting", version, this.resultDeleteResponse, response);
                        },
                        (error) => {
                            this.finishMutation("isDeleting", version, this.resultDeleteError, error);
                        },
                    );
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        resultDeleteResponse(response) {
            this.$bvToast.toast("Sospensione eliminata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });

            this.$emit("onDelete", response);

            // loadData corregge la pagina se l'ultima è rimasta vuota.
            this.loadData();
        },

        resultDeleteError(error) {
            this.$emit("afterLoadData", error);

            this.$bvToast.toast("Errore durante l'eliminazione della sospensione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        // =========================================================
        // UTILITY
        // =========================================================

        finishMutation(flag, version, callback, result) {
            this[flag] = false;

            if (version !== this.contextVersion) {
                if (!this.checkingSospensioneAperta) {
                    this.$emit("afterLoadData");
                }
                return;
            }

            callback(result);
        },

        isRecordAdi(item) {
            return !!(item && (item.tipo === TIPO_SOSPENSIONE_ADI || item.tipo === TIPO_RIPRESA_ADI));
        },

        isSospensioneAperta(item) {
            return !!(item && item.tipo === TIPO_SOSPENSIONE_ADI && item.dataOraUscita && !item.dataOraEntrata);
        },

        isPercorsoRipreso(item) {
            return !!(item && item.tipo === TIPO_RIPRESA_ADI && item.dataOraUscita && item.dataOraEntrata);
        },

        isAccettazioneChiusa() {
            const stato = this.jsonDataAccettazione && this.jsonDataAccettazione.statoAttuale;

            return ["DIMESSO", "DIMISSIONE", "TRASFERITO"].includes(stato);
        },

        toTimestamp(value) {
            if (value === null || value === undefined || value === "") {
                return null;
            }

            let timestamp;

            if (typeof value === "number") {
                timestamp = value;
            } else if (typeof value === "string" && /^-?\d+$/.test(value.trim())) {
                timestamp = Number(value);
            } else {
                timestamp = new Date(value).getTime();
            }

            return Number.isFinite(timestamp) ? timestamp : null;
        },

        clonePresenza(item) {
            return {
                id: item.id,
                idAccettazione: item.idAccettazione,

                dataOraUscitaProgrammata: item.dataOraUscitaProgrammata || null,

                dataOraUscita: item.dataOraUscita || null,

                dataOraEntrataProgrammata: item.dataOraEntrataProgrammata || null,

                dataOraEntrata: item.dataOraEntrata || null,

                tipo: item.tipo || null,
                motivo: item.motivo || null,

                assenteNellaData: item.assenteNellaData,

                noteUscitaProgrammata: item.noteUscitaProgrammata || null,

                noteUscita: item.noteUscita || null,
                noteEntrata: item.noteEntrata || null,
            };
        },

        getEmptySospensione() {
            return createEmptySospensione();
        },

        onCloseModal() {
            if (this.isSaving) return;

            this.$refs.mdlSospensioneAdi.hide();
            this.resetModal();

            this.$emit("onClose");
        },

        resetModal() {
            this.modalMode = null;
            this.jsonDataSospensione = this.getEmptySospensione();
        },
    },
};
</script>

<style scoped>
.note-item {
    margin-bottom: 4px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.sa-table-column-action-double {
    white-space: nowrap;
}

.alert p {
    margin-bottom: 0;
}
</style>
